<template lang="pug">
VitePwaManifest
NuxtLayout
  NuxtPage
</template>

<script setup lang="ts">
onMounted(() => {})
</script>
